// @flow

export default class State {
  id: string;
  name: string;
  location: Array<number>;
  capitalId: string;
  capitalName: string;
  capitalLocation: Array<number>;

  constructor(data: any = {}) {
    this.id = data.id;
    this.name = data.name;
    this.location = data.location;
    if (data.capital_city) {
      this.capitalId = data.capital_city.id;
      this.capitalName = data.capital_city.name;
      this.capitalLocation = data.capital_city.location;
    } else {
      this.capitalId = data.id;
      this.capitalName = data.name;
      this.capitalLocation = data.location;
    }
  }
}
